import React from "react";
import { TextField } from "@mui/material";

export const Input = ({
  label,
  value,
  handleChange,
  name,
  className,
  type,
}) => {
  return (
    <TextField
      inputProps={{
        style: {
          height: "1rem",
        },
      }}
      sx={{
        width: "100%",
        background: "rgb(var(--color-surface))",
        "& label": {
          color: "rgb(var(--color-text-muted))",
          fontFamily: "var(--font-body)",
          fontSize: ".9rem",
        },

        "& input": {
          fontFamily: "var(--font-body)",
          fontSize: ".9rem",
          fontWeight: "400",
          color: "rgb(var(--color-text-secondary))",
        },
        "& .MuiOutlinedInput-root": {
          borderRadius: "8px",
        },
        "& .MuiInputLabel-root": {
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          fontFamily: "nunito",
          fontSize: ".9rem",
          color: "rgb(var(--color-text-muted))",
        },
      }}
      type={type}
      className={className}
      label={label}
      value={value}
      onChange={handleChange}
      name={name}
      variant="outlined"
      fullWidth
      margin="normal"
    />
  );
};
